import React, {FC} from "react";
import {Service} from "../redux/types";
import {useServices} from "../redux/services.hook";
import {Autocomplete} from "@material-ui/lab";
import {CircularProgress, IconButton, makeStyles, TextField} from "@material-ui/core";
import {GridFilterInputValueProps} from "@material-ui/data-grid";
import {Form, Formik, useField} from "formik";
import {useHistory} from "react-router-dom";
import clsx from "clsx";
import * as yup from 'yup';
import {RedCloseIcon} from "../../../sharedComponents/RedCloseIcon";
import {GreenCheckIcon} from "../../../sharedComponents/GreenCheckIcon";

export const ServiceAutoComplete: FC<{ onChange: (services: Service[]) => void, selectedIds?: string[] }> = ({
                                                                                                                 onChange,
                                                                                                                 selectedIds
                                                                                                             }) => {
    const services = useServices();
    return (
        <Autocomplete
            multiple
            options={services}
            value={selectedIds ? services.filter(s => selectedIds.includes(s.id)) : undefined}
            disableCloseOnSelect
            getOptionLabel={(service) => service.name}
            onChange={(_event, selectedServices) => {
                onChange((selectedServices as unknown) as Service[]);
            }}
            renderInput={(params) => <TextField {...params} label="Service"/>}
        />
    )
}

export const FormikServicesAutoComplete: FC<{ name: string }> = ({name}) => {
    const [, meta, helpers] = useField<string[]>(name);

    return (
        <ServiceAutoComplete
            selectedIds={meta.value}
            onChange={(services) => helpers.setValue(services.map(s => s.id))}
        />
    )
}

interface FormikServicesAutoCompleteFormProps {
    onSubmit: (selectedServices: string[]) => Promise<any>;
    initialValues: string[];
    className?: string;
}

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    autoComplete: {
        width: "100%"
    }
}));

const validationSchema = yup.object({serviceIds: yup.array().min(1, "mindestens eine Dienstleistung").required("erforderlich")})


export const ServicesAutoCompleteForm: FC<FormikServicesAutoCompleteFormProps> = (props) => {
    const classes = useStyles();
    const history = useHistory();

    const [isLoading, setIsLoading] = React.useState(false);

    const closeForm = () => history.replace({search: undefined});

    return (
        <Formik
            initialValues={{serviceIds: props.initialValues}}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                setIsLoading(true);
                props.onSubmit(values.serviceIds)
                    .catch(() => {
                    })
                    .finally(() => {
                        setIsLoading(false);
                        closeForm();
                    })
            }}
        >
            {({submitForm}) => (
                <Form className={clsx(props.className, classes.container)}>
                    <FormikServicesAutoComplete name={"serviceIds"}/>
                    {isLoading
                        ? <CircularProgress size={20} color="secondary"/>
                        : (
                            <>
                                <IconButton edge="end" onClick={closeForm}>
                                    <RedCloseIcon/>
                                </IconButton>
                                <IconButton edge="end" onClick={submitForm}>
                                    <GreenCheckIcon/>
                                </IconButton>
                            </>
                        )
                    }
                </Form>
            )}
        </Formik>
    )
}

export function ServiceGridFilterInput(props: GridFilterInputValueProps)
{
    const {item, applyValue} = props;

    const onChangeServices = (services: Service[]) => applyValue({
        ...item,
        value: services.map(s => s.id)
    });

    return (<ServiceAutoComplete onChange={onChangeServices}/>);
}
